/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import Link from '../Link/Link';
const useStyles = makeStyles((theme) => ({
  root: {},
  footerComponent: {
    padding: '135px 0 105px',
    position: 'relative',
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: theme.typography.$fzH6,
    color: theme.palette.$coolGrey,
    zIndex: '100',
    backgroundColor: theme.palette.$lightWhite,
    left: 0,
    '& .footer-component-left': {
      width: '50%',
      '@media (max-width: 768px)': {
        textAlign: 'left',
        width: '100%',
      },
      '& ul': {
        listStyleType: 'none',
        padding: '0',
        margin: '0',
        '& li': {
          display: 'inline-block',
          marginRight: '40px',
          '& a': {
            fontSize: theme.palette.fzH6,
          },
        },
      },
    },
    '& .footer-component-right': {
      color: theme.palette.$slateGrey,
      width: '50%',
      textAlign: 'right',
      '@media (max-width: 768px)': {
        textAlign: 'left',
        width: '100%',
      },
      '@media (max-width: 767px)': {
        width: '100%',
      },
    },
    '@media (max-width: 992px)': {
      display: 'block',
      textAlign: 'left',
      padding: '50px 0px 50px',
      '& .footer-component-left': {
        marginBottom: '20px',
      },
    },
    '@media (max-width: 767px)': {
      display: 'block',
      textAlign: 'left',
      padding: '40px 0',
      lineHeight: 1.75,
      '& .footer-component-left': {
        marginBottom: '20px',
        '& ul': {
          listStyleType: 'none',
          padding: '0',
          margin: '0',
          '& li': {
            display: 'block !important',
            marginRight: '40px',
            lineHeight: '28px',
            width: '100%',
            '& a': {
              fontSize: theme.typography.$fzH6,
            },
          },
        },
      },
    },
  },
  container: {
    maxWidth: '1440px',
    margin: '0 auto',
    padding: '0 10px',
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.footerComponent}>
        <div className="footer-component-left">
          <ul>
            <li>
              <Link
                href="https://www.ocbc.com/group/security/online/index.html"
                color="cool-grey"
                classHover="linkNotUnderLine"
                fontSize="fH6"
              >
                T&Cs
              </Link>
            </li>
            <li>
              <Link
                href="https://www.ocbc.com/personal-banking/conditions-of-access.html"
                color="cool-grey"
                classHover="linkNotUnderLine"
                fontSize="fH6"
              >
                Conditions of Access
              </Link>
            </li>
            <li>
              <Link
                href="http://www.ocbc.com/business-banking/policies.html"
                color="cool-grey"
                classHover="linkNotUnderLine"
                fontSize="fH6"
              >
                Policies

              </Link>
            </li>
            <li>
              <Link
                href="https://www.ocbc.com/personal-banking/notices.html"
                color="cool-grey"
                classHover="linkNotUnderLine"
                fontSize="fH6"
              >
                Notices
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-component-right">
          <span>
            © Copyright 2004 - {new Date().getFullYear()} - OCBC Bank. All Rights Reserved. Co. Reg.
            No.: 193200032W
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
